import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Максимална скорост за твоя сайт',
					text: 'Използваме най-съвременните хостинг технологии, за да осигурим бърза работа на твоя уебсайт. Знаем колко е важно той да се зарежда бързо.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'NVMe SSD',
					subtitle: 'твърди дискове от най-висок клас',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'SuperCache',
					subtitle: 'вградена кешираща система',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'WordPress',
					subtitle: 'оптимизирана среда',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'HTTP/2 и PHP',
					subtitle: 'най-нови версии',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Maximum speed for your site',
					text: 'We use the latest hosting technologies to ensure fast and reliable performance for your website. We know how important fast loading times are.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'NVMe SSD',
					subtitle: 'top-tier solid-state drives',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'SuperCache',
					subtitle: 'built-in caching system',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'WordPress',
					subtitle: 'optimized environment',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'HTTP/2 and PHP',
					subtitle: 'latest versions',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];